import { Reveal } from "./Reveal";
import { Quote } from "lucide-react";

const ITEMS = [
  {
    quote:
      "Leylak rebuilt our entire acquisition engine. Within two quarters our cost per lead halved and pipeline doubled.",
    name: "Sarah Whitfield",
    role: "CMO, Northbank Fintech",
  },
  {
    quote:
      "The most strategic partner we've worked with. They think like owners, not vendors — every decision tied to revenue.",
    name: "Daniel Osei",
    role: "Founder, Atlas Living",
  },
  {
    quote:
      "Our brand finally feels premium. The content and social work put us on the map with a completely new audience.",
    name: "Priya Raman",
    role: "Director, Maison Verde",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 border-b border-white/10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-accent mb-6">Client Words</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-2xl leading-[1.02] mb-16">
            Trusted by brands with ambition.
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {ITEMS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <div className="bg-background p-8 md:p-10 h-full flex flex-col justify-between min-h-[320px]">
                <Quote className="text-accent" size={34} strokeWidth={1.2} />
                <p className="font-display text-xl md:text-2xl leading-snug my-6">"{t.quote}"</p>
                <div>
                  <div className="text-sm font-semibold">{t.name}</div>
                  <div className="text-xs text-muted-foreground mt-1">{t.role}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
